import { BarChart } from '@/common/components/BarChart'
import { LineChart } from '@/common/components/LineChart'
import { ChartType } from '@/common/types/chartType'

export const chartComponents = {
  [ChartType.Bar]: BarChart,
  [ChartType.Line]: LineChart,
}
